import { Element, useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import SpeakersSettings from "@/components/editor/shared/speakers/speakers-settings/speakers-settings-component";
import { PaddingWrapper } from "@/components/editor/themes/crosby/constants";

import SpeakerCard from "./speaker-card/speaker-card-component";
import { SpeakerList } from "./speakers-component-styles";

type SpeakersProps = {
  children?: React.ReactNode;
};

export default function Speakers(props: SpeakersProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper maxWidth="1248px">
          <div className="flex justify-center">
            <Element
              id="speakers-title"
              is={Text}
              element="h2"
              text="Speakers"
              pattern="headingTwo"
              data-testid="speakers-title"
            />
          </div>
          <SpeakerList>{props.children}</SpeakerList>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

Speakers.craft = {
  isCanvas: true,
  custom: {
    displayName: "Speakers",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: () => SpeakersSettings({ template: SpeakerCard }),
  },
};
